import Feature from 'ol/Feature';
import { Geometry } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { LAYER_TYPE } from '@/components/Map/MapViewer/MapViewer.constants';

/**
 * Wraps a comments {@link VectorSource} in a fresh {@link VectorLayer} so each
 * map can render the shared source with its own layer object.
 */
export const createCommentsLayer = (
  source: VectorSource<Feature<Geometry>>,
): VectorLayer<VectorSource<Feature<Geometry>>> => {
  const vectorLayer = new VectorLayer({
    // eslint-disable-next-line no-magic-numbers
    zIndex: Infinity,
    source,
  });
  vectorLayer.set('type', LAYER_TYPE.COMMENTS_LAYER);
  return vectorLayer;
};
